export default __webpack_public_path__ + "static/media/more-view-arrow-white.fea14fe1.svg";